export enum SettingsTemplateType {
  INPUT = 'input',
  BACKTEST_CONFIG = 'backtest_config',
  SESSION_CONFIG = 'session_config',
}

export interface SettingsTemplate {
  id: string
  userId: string
  scriptId?: string | null
  name: string
  type: SettingsTemplateType
  config: Record<string, unknown>
  metadata?: Record<string, unknown> | null
  createdAt: string
  updatedAt: string
}

export interface CreateSettingsTemplateDto {
  name: string
  type: SettingsTemplateType
  config: Record<string, unknown>
  metadata?: Record<string, unknown>
  scriptId?: string
}

export interface UpdateSettingsTemplateDto {
  name?: string
  config?: Record<string, unknown>
  metadata?: Record<string, unknown>
}
